









































































































































































































































































































































































































import Vue from 'vue'
import api from '@/helpers/fetch'

const DEFAULT_TRANSICAO: Record<number, number> = {
	2026: 0.1,
	2027: 0.2,
	2028: 0.3,
	2029: 0.4,
	2030: 0.5,
	2031: 0.6,
	2032: 0.7,
	2033: 1.0,
}

const DEFAULT_FORM = () => ({
	cbs: 8.8,
	ibs: 17.7,
	creditoEfetivo: 85,
	creditoPresumidoSimples: 70,
	prazoFloatDias: 30,
	taxaCapitalGiro: 1.8,
	transicao: { ...DEFAULT_TRANSICAO },
	nota: '',
})

export default Vue.extend({
	name: 'SARTAdmin',

	data() {
		return {
			anos: [2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033],
			anoAtual: new Date().getFullYear(),

			config: {} as Record<string, any>,
			original: DEFAULT_FORM(),
			form: DEFAULT_FORM(),

			simReceita: 0,
			saving: false,
			saveOk: false,
			erros: [] as string[],
			showResetModal: false,
		}
	},

	computed: {
		totalAliquota(): string {
			return (
				parseFloat(String(this.form.cbs || 0)) +
				parseFloat(String(this.form.ibs || 0))
			).toFixed(2)
		},
		isDirty(): boolean {
			return JSON.stringify(this.form) !== JSON.stringify(this.original)
		},
	},

	mounted() {
		this.loadConfig()
	},

	methods: {
		async loadConfig() {
			try {
				const data = await api.get('/api/sart/admin/config')
				this.config = data
				this.original = this.cloneConfig(data)
				this.form = this.cloneConfig(data)
			} catch (e) {
				console.error('[SARTAdmin] loadConfig:', e)
			}
		},

		async saveConfig() {
			this.erros = []
			this.saveOk = false

			if (this.form.cbs < 0 || this.form.cbs > 30) {
				this.erros.push('CBS deve estar entre 0 e 30.')
			}
			if (this.form.ibs < 0 || this.form.ibs > 30) {
				this.erros.push('IBS deve estar entre 0 e 30.')
			}
			if (this.erros.length) return

			this.saving = true
			try {
				const data = await api.post('/api/sart/admin/config', this.form)
				if (data.erros) {
					this.erros = data.erros
					return
				}
				this.config = data.config
				this.original = this.cloneConfig(data.config)
				this.form = this.cloneConfig(data.config)
				this.saveOk = true
				setTimeout(() => {
					this.saveOk = false
				}, 4000)
			} catch (e) {
				this.erros = ['Erro ao salvar. Verifique o servidor.']
			} finally {
				this.saving = false
			}
		},

		confirmReset() {
			this.showResetModal = true
		},

		async doReset() {
			this.showResetModal = false
			this.saving = true
			try {
				const data = await api.post('/api/sart/admin/config/reset', {})
				this.config = data.config
				this.original = this.cloneConfig(data.config)
				this.form = this.cloneConfig(data.config)
			} catch (e) {
				this.erros = ['Erro ao restaurar padrões.']
			} finally {
				this.saving = false
			}
		},

		setFator(ano: number, val: string) {
			const num = parseFloat(val)
			if (!isNaN(num)) {
				this.$set(
					this.form.transicao,
					ano,
					Math.min(1, Math.max(0, num)),
				)
			}
		},

		pct(val: number): string {
			return `${(parseFloat(String(val || 0)) * 100).toFixed(0)}%`
		},

		cloneConfig(obj: any): any {
			return JSON.parse(JSON.stringify(obj))
		},

		formatDate(iso: string): string {
			return new Date(iso).toLocaleString('pt-BR', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			})
		},

		formatMoeda(val: number): string {
			return Math.round(val).toLocaleString('pt-BR')
		},
	},
})
